import { render } from "./StockNotificationV2.vue?vue&type=template&id=3e66ef92&scoped=true"
import script from "./StockNotificationV2.vue?vue&type=script&lang=js"
export * from "./StockNotificationV2.vue?vue&type=script&lang=js"

import "./StockNotificationV2.vue?vue&type=style&index=0&id=3e66ef92&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e66ef92"]])

export default __exports__